import { memo } from 'react';
import { RowContentType, RowIdType } from '../../../../../../types';
import { ImageHighlighterWrapper } from '../../../../../imageHighlighter/imageHighlighter';
import { Select } from 'semantic-ui-react';
import { getOptions } from '../../../../../../utils/tableExtraction';
import { SUPPORTED_FIELD_VALUES } from '../../../../constants';
import {
    useChangeRowMetadata,
    useIsRowImportCandidate,
    useRowContentType,
} from '../../../../../../stores/metadataStore';
import { useRowBoundingBox } from '../../../../../../stores/boundingBoxesStore';
import { ROW_TYPE } from '../../../../../../constants/generalConstants';

type RowContentTypeControlPropsType = {
    rowId: RowIdType;
};
const RowContentTypeControl = memo(function RowContentTypeControl({ rowId }: RowContentTypeControlPropsType) {
    const isImportCandidate = useIsRowImportCandidate(rowId);
    const contentType = useRowContentType(rowId);
    const changeRowMetadata = useChangeRowMetadata();
    const boundingBox = useRowBoundingBox(rowId);

    return (
        <ImageHighlighterWrapper boundingBox={boundingBox}>
            <Select
                disabled={!isImportCandidate}
                value={contentType}
                options={getOptions(SUPPORTED_FIELD_VALUES.ROW_TYPES)}
                onChange={(__, data) => {
                    if (data.value === ROW_TYPE.EMPTY || data.value === ROW_TYPE.TABLE_HEADER) {
                        changeRowMetadata(rowId, { contentType: data.value as RowContentType, importCandidate: false });
                    } else {
                        changeRowMetadata(rowId, { contentType: data.value as RowContentType });
                    }
                }}
            />
        </ImageHighlighterWrapper>
    );
});

export default RowContentTypeControl;
